var base = require('settings/teams/ai-settings');

Vue.component('spark-ai-settings', {
    mixins: [base]
});
